import { useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { rateShop } from '../api/shops';
import { Button, Card, ErrorText, FormInput } from './ui';
import { colors } from '../theme';
import { ApiError } from '../api/client';

interface Props {
  token: string;
  shopId: string;
  submissionId: string;
}

/** Lets a reviewer rate their in-person experience with a shop after a task
 * concludes (approved or rejected) — separate from the public Google review,
 * this is what future reviewers see to spot shops that treat people fairly. */
export function ShopRatingForm({ token, shopId, submissionId }: Props) {
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  if (done) {
    return (
      <Card>
        <Text style={{ color: colors.success, fontWeight: '600' }}>
          Cảm ơn bạn đã đánh giá trải nghiệm với shop này!
        </Text>
      </Card>
    );
  }

  const onSubmit = async () => {
    if (stars < 1) {
      setError('Chọn số sao trước khi gửi');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await rateShop(token, shopId, submissionId, stars, comment || undefined);
      setDone(true);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Gửi đánh giá thất bại');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card>
      <Text style={{ fontWeight: '700', color: colors.text, marginBottom: 8 }}>
        Đánh giá trải nghiệm với shop này
      </Text>
      <Text style={{ color: colors.textMuted, fontSize: 13, marginBottom: 10 }}>
        Riêng tư, chỉ hiển thị điểm trung bình cho người làm nhiệm vụ sau — giúp mọi người biết shop
        nào đối xử công bằng.
      </Text>
      <View style={{ flexDirection: 'row', gap: 6, marginBottom: 10 }}>
        {[1, 2, 3, 4, 5].map((n) => (
          <Pressable key={n} onPress={() => setStars(n)}>
            <Text style={{ fontSize: 28, color: n <= stars ? colors.warning : colors.border }}>★</Text>
          </Pressable>
        ))}
      </View>
      <FormInput
        value={comment}
        onChangeText={setComment}
        placeholder="Nhận xét thêm (tuỳ chọn)"
        multiline
      />
      <ErrorText>{error}</ErrorText>
      <Button title="Gửi đánh giá" onPress={onSubmit} loading={busy} disabled={stars < 1} />
    </Card>
  );
}
